import {SORespInvoiceLine} from '../../core/invoice-line/so-resp-invoice-line';
import {InvoiceLineCore} from './invoice-line.core';
import {ListEntry, CEProtocol, CEBase, createCEProtocol, RowSpec} from 'lionheartland';
import {
  DetailEntry, ScopeMatch,
  DetailFactory, DetailFactoryProtocol, EditableType
} from 'lionheartland';
import {BaseDetailType} from 'lionheartland';
import {EntityAttributesForDisplay} from 'lionheartland';
import {getHeading} from 'lionheartland';
import {ListSpecType} from 'lionheartland';
import {DisplayVectorStringFactory} from 'lionheartland';
import {ActiveUserService} from 'lionheartland';
import {EntityViewSpecProtocol} from 'lionheartland';
import { CommanderApp } from "../../land-app";
import {PutInvoiceLineFormFields} from './put-invoice-line-form-fields';
import {SOGetInvoiceLine} from '../../core/invoice-line/so-get-invoice-line';
import {SOGetPrice} from '../../core/price/so-get-price';
import {SOGetInvoice} from '../../core/invoice/so-get-invoice';


export class CEInvoiceLineAttributesBase {

    amount: DetailEntry
    quantity: DetailEntry
    dateCreated: DetailEntry
    description: DetailEntry
    price: DetailEntry
    invoice: DetailEntry

    constructor(
        parentEntityViewSpec: EntityViewSpecProtocol,
        entity: SORespInvoiceLine,
        app: CommanderApp,
        formFields: PutInvoiceLineFormFields
    ) {

        const displayStringFactory = new DisplayVectorStringFactory(app.displayOptions);
        let heading;


        this.amount = new DetailEntry(
            'Amount',
            entity.amount,
            'amount',
            BaseDetailType.text,
            null,
            EditableType.always,
            formFields.amount
        )

        this.quantity = new DetailEntry(
            'Quantity',
            entity.quantity,
            'quantity',
            BaseDetailType.text,
            null,
            EditableType.always,
            formFields.quantity
        )

        this.dateCreated = new DetailEntry(
            'Date created',
            app.activeUserService.time.dateAsString(entity.dateCreated),
            'dateCreated',
            BaseDetailType.text,
            null,
            EditableType.never,
        )

        this.description = new DetailEntry(
            'Description',
            entity.description,
            'description',
            BaseDetailType.text,
            null,
            EditableType.always,
            formFields.description
        )


        const priceCore = app.makeCore( 'price');
        priceCore.soGet = SOGetPrice.construct({
        });
        let priceCeProtocol;
        if (entity.price) {
            priceCeProtocol = createCEProtocol(
                priceCore.ceProtocol,
                parentEntityViewSpec,
                priceCore,
                entity.price,
                app
            )
        }
        heading = getHeading(
            parentEntityViewSpec ? parentEntityViewSpec.entityCore : null,
            priceCore
        )
        priceCore.title = heading ? heading : priceCore.title
        priceCore.listTitle = 'Price'

        if (entity.price) {
            displayStringFactory.reconfigure(
                entity.price,
                parentEntityViewSpec ? parentEntityViewSpec.entityCore.type : null
            )
        }
        priceCore.configureForDisplay(parentEntityViewSpec)

        this.price = new DetailEntry(
          heading ? heading : priceCore.listTitle,
          priceCeProtocol ? priceCeProtocol.entityListView.fullHeading : null,
          'price',
          BaseDetailType.pushedDetail,
          priceCore,
          EditableType.always,
          formFields.price
        )
        if (entity.price) {
          this.price.ceProtocol = priceCeProtocol;
          this.price.cachedListEntry = priceCore.makeListEntry(parentEntityViewSpec, entity.price, 0)
          priceCore.selectedEntity = entity.price;
        }
        this.price.singleFieldSelect = true

        const invoiceCore = app.makeCore( 'invoice');
        invoiceCore.soGet = SOGetInvoice.construct({
        });
        let invoiceCeProtocol;
        if (entity.invoice) {
            invoiceCeProtocol = createCEProtocol(
                invoiceCore.ceProtocol,
                parentEntityViewSpec,
                invoiceCore,
                entity.invoice,
                app
            )
        }
        heading = getHeading(
            parentEntityViewSpec ? parentEntityViewSpec.entityCore : null,
            invoiceCore
        )
        invoiceCore.title = heading ? heading : invoiceCore.title
        invoiceCore.listTitle = 'Invoice'

        if (entity.invoice) {
            displayStringFactory.reconfigure(
                entity.invoice,
                parentEntityViewSpec ? parentEntityViewSpec.entityCore.type : null
            )
        }
        invoiceCore.configureForDisplay(parentEntityViewSpec)

        this.invoice = new DetailEntry(
          heading ? heading : invoiceCore.listTitle,
          invoiceCeProtocol ? invoiceCeProtocol.entityListView.fullHeading : null,
          'invoice',
          BaseDetailType.pushedDetail,
          invoiceCore,
          EditableType.always,
          formFields.invoice
        )
        if (entity.invoice) {
          this.invoice.ceProtocol = invoiceCeProtocol;
          this.invoice.cachedListEntry = invoiceCore.makeListEntry(parentEntityViewSpec, entity.invoice, 0)
          invoiceCore.selectedEntity = entity.invoice;
        }
        this.invoice.singleFieldSelect = true
    }
}